
































































import Background from './Background'
import GameOverview from './GameOverview'
import SiteOverview from './SiteOverview'


export default
  components: { Background, GameOverview, SiteOverview }

  metaInfo:
    title: 'redka.games'

  data: ->
    selectedGame: null
    games: [
      {
        name: 'Mages'
        game: 'mages'
        path: '/mages'
        bgClass: 'mages-bg'
        video: 'https://firebasestorage.googleapis.com/v0/b/redka-games.appspot.com/o/mages.mp4?alt=media&token=38761681-14a1-44ea-82d7-886001779539',
        tagline: 'Mage fighting elimination arena where you customize by purchasing spells from the shop. Your mission is to outlast everyone else in a shrinking map with lava encroaching.'
      },
      {
        name: 'Shootout'
        game: 'shootout'
        path: '/shootout'
        bgClass: 'shootout-bg'
        # video: 'https://firebasestorage.googleapis.com/v0/b/redka-games.appspot.com/o/mages.mp4?alt=media&token=38761681-14a1-44ea-82d7-886001779539',
        tagline: 'Fast-paced third person shooter with proper netcode and bullets actually simulated as projectiles'
        isPrototype: true
      },
      {
        name: 'Fat Hooks'
        game: 'fat-hooks'
        path: '/fat-hooks'
        bgClass: 'fat-hooks-bg',
        tagline: 'Physics based chain hooking across a river in two teams'
        isPrototype: true
      },
      {
        name: 'Mages Soccer'
        game: 'mages'
        path: '/mages-soccer'
        bgClass: 'mages-soccer-bg'
        video: 'https://firebasestorage.googleapis.com/v0/b/redka-games.appspot.com/o/mages_soccer.mp4?alt=media&token=4998fe01-922b-4e49-aa48-b4638e86ed13',
        tagline: "Spells from Mages but here it's about scoring goals with a huge concrete ball"
        isOutOfOrder: true
      }
    ]

  created: ->
    @selectGame(@games.find(_.path.is @$route.path))

  watch:
    '$route': ({ path }) ->
      @selectGame(@games.find(_.path.is path))

  methods:
    selectGame: (game) ->
      @selectedGame = game
      @$router.push(game.path) if game and @$route.path isnt game.path

